"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const reselect_1 = require("reselect");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const recompose_1 = require("recompose");
const selectors_1 = require("@zedoc/selectors");
const QuestionnaireContext_1 = __importStar(require("./QuestionnaireContext"));
const SelectorsHub_1 = __importDefault(require("./SelectorsHub"));
class Element extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.getContext = (0, reselect_1.createSelector)((0, selectors_1.argument)(0, 'context'), (0, selectors_1.argument)(0, 'id'), (context, elementId) => {
            if (context) {
                return context.createSubContext(elementId);
            }
            return null;
        });
        this.handleMoveUp = this.handleMoveUp.bind(this);
        this.handleMoveDown = this.handleMoveDown.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
    }
    handleRemove() {
        const { id, dispatch, context, contextOptions } = this.props;
        if (contextOptions && contextOptions.disabled) {
            return;
        }
        dispatch(context.removeElement(id));
    }
    handleMoveUp() {
        const { id, dispatch, context, contextOptions } = this.props;
        if (contextOptions && contextOptions.disabled) {
            return;
        }
        dispatch(context.moveElementUp(id));
    }
    handleMoveDown() {
        const { id, dispatch, context, contextOptions } = this.props;
        if (contextOptions && contextOptions.disabled) {
            return;
        }
        dispatch(context.moveElementDown(id));
    }
    render() {
        const _a = this.props, { children } = _a, props = __rest(_a, ["children"]);
        if (typeof children === 'function') {
            return (react_1.default.createElement(QuestionnaireContext_1.default.Provider, { value: this.getContext(props) }, children({
                handleRemove: this.handleRemove,
                handleMoveUp: this.handleMoveUp,
                handleMoveDown: this.handleMoveDown,
            })));
        }
        return (react_1.default.createElement(QuestionnaireContext_1.default.Provider, { value: this.getContext(props) }, children));
    }
}
Element.propTypes = {
    id: prop_types_1.default.string.isRequired,
    children: prop_types_1.default.oneOfType([prop_types_1.default.node, prop_types_1.default.func]),
    dispatch: prop_types_1.default.func.isRequired,
    context: prop_types_1.default.instanceOf(SelectorsHub_1.default).isRequired,
    contextOptions: prop_types_1.default.shape({
        disabled: prop_types_1.default.bool,
    }),
};
Element.defaultProps = {
    children: null,
    contextOptions: null,
};
exports.default = (0, recompose_1.compose)((0, QuestionnaireContext_1.withContext)(), (0, react_redux_1.connect)(() => {
    return (0, reselect_1.createStructuredSelector)({
        contextOptions: (0, selectors_1.higherOrderSelector)((0, selectors_1.property)('context'), (context) => context.select.options()),
    });
}, null))(Element);
//# sourceMappingURL=Element.js.map